/**
 * 非凡工作官网配置文件
 * 所有可配置的链接和设置都在这里管理
 */

const config = {
  // 网站基本信息
  site: {
    name: '非凡工作',
    domain: 'nuwork.cn',
    title: '非凡工作 Nuwork — 人人做 APP，APP 来接客',
    description: '非凡工作 Nuwork：人人做 APP，APP 来接客。让每个人都能创造自己的 AI 应用，展示自我、衔接需求、拉通工作、协同伙伴。',
    themeColor: '#f4f7fb',
  },

  // 应用市场相关链接 - 跳转到 nuwork-app 前端 (开发环境)
  market: {
    // 应用市场主页
    home: '/app/',
    // 发布应用页面
    publish: '/app/#/publish',
    // 账户管理页面 (管理我的应用)
    account: '/app/#/account',
  },

  // 产品入口 - 跳转到 nuwork-app 前端 (生产环境)
  product: {
    // 产品工作台入口
    entry: '/app/',
    // 状态查询页面
    status: '/app/#/status',
  },

  // API 端点配置
  api: {
    smsCode: '/api/v1/auth/sms/code',
    smsVerify: '/api/v1/auth/sms/verify',
    tenantOpen: '/api/v1/tenants/open',
    smsLogin: '/api/v1/auth/sms/login',
  },

  // 法律文档
  legal: {
    terms: {
      path: '/legal/terms',
      version: '2026-08-03',
      title: '服务条款',
    },
    privacy: {
      path: '/legal/privacy',
      version: '2026-08-03',
      title: '隐私政策',
    },
  },

  // 发布者信息（应用市场）
  publisher: {
    id: 'linyi',
    name: '林一工作室',
    mark: '林',
    bio: '把真实工作方法做成可运行的 AI APP。',
  },

  // 应用市场应用列表
  apps: [
    {
      id: 'customer-concierge',
      title: 'AI 客户接待官',
      art: '接住每一次询单',
      tag: '客户接待',
      tags: ['客户接待', '销售'],
      accent: '#53a5ff',
      deep: '#112d55',
      desc: '识别客户意图、提炼关键需求，并生成下一步接待建议。',
      action: '分析客户需求',
      result: '已识别采购意向：高；建议先确认数量、交付时间与预算范围。',
      data: { customer: '某消费电子品牌', channel: '微信', intent: '批量采购', quantity: 1200, deadline: '本月末' },
      workflow: ['读取客户原话与历史背景', '识别意图、约束和缺失信息', '匹配产品与接待策略', '输出可直接发送的回复'],
      stats: [['询单', '28'], ['高意向', '9'], ['待跟进', '4']],
      rows: [['预算与数量', '需要确认'], ['交付时间', '本月末'], ['推荐动作', '发送方案']],
    },
    {
      id: 'meeting-insight',
      title: '会议战果生成器',
      art: '会后即刻形成战果',
      tag: '会议',
      tags: ['会议', '项目协同'],
      accent: '#806df7',
      deep: '#251b58',
      desc: '把会议记录变成结论、负责人、截止时间和可继续协同的任务清单。',
      action: '生成会议战果',
      result: '已生成 3 项结论、4 个行动项，并标记 1 个待确认风险。',
      data: { meeting: '新品上市评审', attendees: 8, duration: '52 分钟', transcriptSegments: 186 },
      workflow: ['读取会议纪要或逐字稿', '区分事实、观点与决定', '抽取负责人和截止时间', '生成可追问的战果文件'],
      stats: [['结论', '3'], ['行动项', '4'], ['风险', '1']],
      rows: [['确认首发渠道', 'Leo · 周五'], ['补齐成本测算', 'Mia · 明天'], ['更新上市节奏', '产品组']],
    },
    {
      id: 'sales-dashboard',
      title: '经营数据脉搏',
      art: '一眼看懂今天的生意',
      tag: '数据分析',
      tags: ['数据分析', '销售'],
      accent: '#36b7a0',
      deep: '#0d3c43',
      desc: '把多渠道经营数据汇成可追问的日看板，自动定位异常和增长来源。',
      action: '刷新经营分析',
      result: '今日销售额较昨日提升 18%，增长主要来自独立站新品与美国站自然流量。',
      data: { date: '2026-08-12', currency: 'USD', shopify: 48620, amazon: 72340, b2b: 21800 },
      workflow: ['读取已授权的渠道数据', '统一币种与统计口径', '计算变化并定位异常', '生成可下钻的经营摘要'],
      stats: [['销售额', '$142k'], ['环比', '+18%'], ['异常', '2']],
      rows: [['Shopify 新品', '+31%'], ['Amazon US', '+12%'], ['B2B 询盘', '+8%']],
    },
    {
      id: 'content-studio',
      title: '内容灵感工作台',
      art: '从洞察到成稿',
      tag: '内容创作',
      tags: ['内容创作', '客户接待'],
      accent: '#f277ae',
      deep: '#592040',
      desc: '将产品资料、用户反馈和品牌语气组合成可发布的内容草稿。',
      action: '生成内容方案',
      result: '已生成 3 个内容角度，并按品牌语气完成首版短文与标题。',
      data: { product: 'Nuwork', audience: '创新团队', channels: ['公众号', '小红书', 'LinkedIn'], tone: '克制、聪明、具体' },
      workflow: ['汇总产品事实与用户洞察', '选择内容目标和渠道', '按品牌语气生成初稿', '检查事实并输出多渠道版本'],
      stats: [['角度', '3'], ['渠道', '3'], ['事实检查', '通过']],
      rows: [['产品洞察', '工作成果会流动'], ['用户痛点', '背景反复解释'], ['主标题', '让成果继续工作']],
    },
    {
      id: 'project-handoff',
      title: '项目交付中枢',
      art: '完整工程一次交付',
      tag: '项目协同',
      tags: ['项目协同', '会议'],
      accent: '#f3a64d',
      deep: '#53300c',
      desc: '整理代码、数据、说明与变更记录，让接收方拿到即可继续工作。',
      action: '检查交付完整性',
      result: '工程包完整度 96%，缺少 1 项生产环境变量说明，已生成补齐建议。',
      data: { project: 'Nuwork 官网', files: 48, codeFiles: 31, dataFiles: 6, docs: 11, version: 'v1.8.0' },
      workflow: ['扫描工程目录与版本信息', '核对数据、代码和工作流', '生成运行与交付说明', '输出完整工程包'],
      stats: [['文件', '48'], ['完整度', '96%'], ['待补齐', '1']],
      rows: [['/src', '31 files'], ['/data', '6 files'], ['README', '已更新']],
    },
    {
      id: 'research-brief',
      title: '研究简报助手',
      art: '把资料变成判断',
      tag: '数据分析',
      tags: ['数据分析', '内容创作'],
      accent: '#5f82e8',
      deep: '#172852',
      desc: '梳理多份资料的事实、分歧和证据，生成结构清楚的决策简报。',
      action: '生成研究简报',
      result: '已归纳 5 项事实、2 个主要分歧和 3 条待验证假设。',
      data: { topic: 'AI 应用市场', sources: 12, notes: 37, evidenceItems: 24 },
      workflow: ['导入资料与原始笔记', '标记事实、观点和来源', '比较分歧并形成假设', '生成带证据索引的简报'],
      stats: [['来源', '12'], ['证据', '24'], ['假设', '3']],
      rows: [['用户愿意先体验', '高置信'], ['源码可得性关键', '中高置信'], ['发布者影响获取', '待验证']],
    },
  ],

  // 应用市场标签
  marketTags: ['全部', '客户接待', '会议', '数据分析', '内容创作', '项目协同'],

  // Hero 区域六张接待卡片数据
  heroCards: [
    {
      id: 'client',
      number: '01',
      tag: 'CLIENT',
      title: '接待客户',
      promise: '全天候，接住每一次询单。',
      detail: '它替你展示最好的产品，听懂需求，接住询单——你睡觉的时候，它也在营业。',
    },
    {
      id: 'team',
      number: '02',
      tag: 'TEAM',
      title: '接待同事',
      promise: '背景一次讲清，拿来就能继续做。',
      detail: '你产出的信息全貌，它替你讲清楚。同事拿来就能二次加工，不用再追着你要背景。',
    },
    {
      id: 'leadership',
      number: '03',
      tag: 'LEADERSHIP',
      title: '接待领导',
      promise: '报告聚焦，追问始终有答案。',
      detail: '一份聚焦的报告，一个全量的 ZIP，它替你持续回答追问。无惧领导追问，坦荡信息穿透。',
    },
    {
      id: 'partner',
      number: '04',
      tag: 'PARTNER',
      title: '接待伙伴',
      promise: '创意，在连接里长出来。',
      detail: '伙伴直接和你的 APP 协同，而不是在会议里磨出来。',
    },
    {
      id: 'data',
      number: '05',
      tag: 'DATA',
      title: '接通数据',
      promise: '一次接通，全员随时可用。',
      detail: '数据只接通一次，所有人都能随时调用。',
    },
    {
      id: 'future',
      number: '06',
      tag: 'FUTURE',
      title: '连接未来',
      promise: '今天创造，定义明天。',
      detail: '今天做 AI APP 的人，定义明天的工作方式。',
    },
  ],

  // Orbit 区域六种成果复利数据
  orbitItems: [
    {
      id: 'results',
      number: '01',
      tag: 'RESULTS',
      metric: 'WORK',
      title: '设计成果',
      desc: '数据分析、视觉设计、产品方案、产品文档，随时发布。',
    },
    {
      id: 'app',
      number: '02',
      tag: 'APP',
      metric: 'APP',
      title: '发布应用',
      desc: '数据 + Skill + 视觉呈现 = 完整应用，自动服务你的客户。',
    },
    {
      id: 'online',
      number: '03',
      tag: 'ONLINE',
      metric: 'HTML',
      title: '公网发布',
      desc: 'HTML 自动部署到服务器，iPhone 随时可以打开。',
    },
    {
      id: 'share',
      number: '04',
      tag: 'SHARE',
      metric: 'WX',
      title: '微信分享',
      desc: '把自己设计的作品分享到微信，帮助更多人。',
    },
    {
      id: 'project',
      number: '05',
      tag: 'PROJECT',
      metric: 'ZIP',
      title: '工程分享',
      desc: '一句话获取完整工程文件，共享成果，继续二次开发。',
    },
    {
      id: 'brand',
      number: '06',
      tag: 'PROFILE',
      metric: 'ME',
      title: '个人中心',
      desc: '聚集你的全部 AI 产出，打造个人品牌。',
    },
  ],

  // P3 解决做应用困难的六个方案
  fstageCards: [
    {
      id: 'deploy',
      number: '01',
      tag: 'DEPLOY',
      title: '简单部署',
      features: ['无需注册域名', '无需备案与配置服务器', '无需先注册微信账号', 'HTML 发布后即可公网访问'],
    },
    {
      id: 'run',
      number: '02',
      tag: 'RUN',
      title: '立即运行',
      features: ['网页先直接预览效果', '在 workbuddy 中运行完整程序', '在 Codex 中继续修改', '在 Claude Code 中接着开发'],
    },
    {
      id: 'platform',
      number: '03',
      tag: 'PLATFORM',
      title: '基于开发平台的 APP',
      features: ['基于成熟开发平台完成应用', '数据、Skill 与视觉呈现协同生成', '复用现有能力，不必从零开发', '开发成本降到原来的 1/10'],
    },
    {
      id: 'create',
      number: '04',
      tag: 'CREATE',
      title: '人人可编程',
      features: ['不要求代码基础', '用自然语言表达要解决的问题', '数据、Skill 与界面逐步生成', '随时做出自己的应用'],
    },
    {
      id: 'align',
      number: '05',
      tag: 'ALIGN',
      title: '最快的内部沟通',
      features: ['为上游做一个理解需求的应用', '为下游做一个接住结果的应用', '复杂信息被结构化、穿透表达', '让上下游真正理解彼此'],
    },
    {
      id: 'customer',
      number: '06',
      tag: 'CUSTOMER',
      title: '最懂你的客户',
      features: ['在开发平台内持续沟通', '把客户背景和需求留在上下文', '随时生成定制解决方案', '成为最懂客户的人'],
    },
  ],

  // FAQ 数据
  faq: [
    {
      id: 'what-is',
      question: '非凡工作是什么?',
      answer: '非凡工作让每个人都能把自己的工作方法做成 AI APP，用来展示自我、接待需求、衔接工作、协同伙伴，并把一次创造变成可以持续使用的成果。',
    },
    {
      id: 'can-use',
      question: '应用市场里的应用能直接使用吗?',
      answer: '可以。应用提供 HTML 时可在线查看和运行；发布者同时提供 ZIP 时，可再获取完整工程并继续修改。',
    },
    {
      id: 'what-get',
      question: '获取应用后会得到什么?',
      answer: '有 HTML 时可以先查看运行效果；提供 ZIP 时可以获取完整工程；仅 ZIP 的应用则直接下载、解压后使用。',
    },
    {
      id: 'need-login',
      question: '使用应用市场需要登录吗?',
      answer: '不需要。浏览、预览、获取和公开发布都不会被账号拦截；个人中心只整理当前设备上的收藏、最近打开、获取记录和发布记录。',
    },
    {
      id: 'can-publish',
      question: '我可以发布自己的应用吗?',
      answer: '可以。上传 HTML、HTM 或 ZIP 完整工程并补充应用信息即可公开发布，在线版本单个文件最大 300 MB；发布前请确认你拥有相应内容和文件的发布权。',
    },
  ],
};

export default config;
